module.exports = __webpack_public_path__ + "fonts/LineIconsPro Light.c13d2ac.ttf";